module.exports = {
  "time-dot-wrap": {
    "flexDirection": "row",
    "alignItems": "center"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-9e494f96!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/wxc-countdown/index.vue
// module id = 189
// module chunks = 0 1